<template>
  <div class="row">
    <div class="col-lg-12 text-center">
      <PercentageCircle :percentage="percentages[0]" />
      <span class="font-weight-bold d-block">{{ recruiter_name }}</span>
      <span class="d-block"
        >TAXA DE CONCLUSÃO<br />
        DE VAGAS</span
      >
    </div>
    <hr class="w-75" />
    <div class="col-lg-12 text-center">
      <PercentageCircle :percentage="percentages[1]" />
      <span class="font-weight-bold d-block">{{ recruiter_name }}</span>
      <span class="d-block">TAXA DE CONTRATAÇÃO<br /> DE CANDIDATOS(AS)</span>
    </div>
  </div>
</template>

<script>
import PercentageCircle from "components/PercentageCircle.vue";

export default {
  props: ["percentages", "recruiter_name"],
  components: { PercentageCircle },
};
</script>